import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { setToogleHeader } from "../../core/redux/action";
import { useDispatch, useSelector } from "react-redux";
import { ChevronUp } from "feather-icons-react/build/IconComponents";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import AddPurchaseReturn from "../../core/modals/purchases/addpurchasereturn";
import EditPurchaseReturns from "../../core/modals/purchases/editpurchasereturns";
// import Swal from 'sweetalert2';
// import withReactContent from 'sweetalert2-react-content';
import { useToast } from "../../Toaster/ToastContext";
import Loader from "../loader/loader";
import { apiClient } from "../../services/apiClient";
import { Table } from "antd";


const PurchaseReturns = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [purchases, setPurchases] = useState([]);
  const [filteredPurchases, setFilteredPurchases] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const hasFetched = useRef(false);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    totalPages: 0,
    totalCount: 0,
  });

  const fetchPurchases = async (page = 1, size = pagination.pageSize) => {
    if (hasFetched.current) return;
    setLoading(true);
    try {
      const response = await apiClient.post("/get-all-purchase", {
        pageIndex: page - 1,
        pageSize: size,
        previousPageIndex: page - 1,
      });
      if (response.success) {
        const returnPurchases = (response.data || []).filter(
          (purchase) =>
            purchase.status &&
            typeof purchase.status === "string" &&
            purchase.status.toLowerCase() === "returned"
        );
        setPurchases(returnPurchases);
        setFilteredPurchases(returnPurchases);
        setPagination((prev) => ({
          ...prev,
          currentPage: page,
          totalCount: returnPurchases.length,
          totalPages: Math.ceil(returnPurchases.length / size),
        }));
      } else {
        setPurchases([]);
        setFilteredPurchases([]);
        setPagination((prev) => ({
          ...prev,
          currentPage: 1,
          totalCount: 0,
          totalPages: 0,
        }));
      }
    } catch (error) {
      showToast(
        error.message || "Failed to fetch purchases",
        "error",
        "Purchases"
      );
      setPagination((prev) => ({
        ...prev,
        currentPage: 1,
        totalCount: 0,
        totalPages: 0,
      }));
    } finally {
      setLoading(false);
      hasFetched.current = true;
    }
  };

  useEffect(() => {
    fetchPurchases();
  }, []);

  // const handleSearch = (e) => {
  //   const term = e.target.value.toLowerCase();

  //   setFilteredPurchases(
  //     purchases.filter((purchase) => {
  //       const supplier =
  //         purchase.supplier_name && typeof purchase.supplier_name === "string"
  //           ? purchase.supplier_name.toLowerCase()
  //           : "";
  //       const reference =
  //         purchase.reference && typeof purchase.reference === "string"
  //           ? purchase.reference.toLowerCase()
  //           : "";

  //       return supplier.includes(term) || reference.includes(term);
  //     })
  //   );
  // };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    const filtered = purchases.filter((purchase) => {
      const supplier =
        purchase.supplier_name && typeof purchase.supplier_name === "string"
          ? purchase.supplier_name.toLowerCase()
          : "";
      const reference =
        purchase.reference && typeof purchase.reference === "string"
          ? purchase.reference.toLowerCase()
          : "";
      return supplier.includes(term) || reference.includes(term);
    });
    setFilteredPurchases(filtered);
    // CHANGE: Update pagination on search
    setPagination((prev) => ({
      ...prev,
      currentPage: 1, // Reset to page 1
      totalCount: filtered.length,
      totalPages: Math.ceil(filtered.length / prev.pageSize),
    }));
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );
  // const MySwal = withReactContent(Swal);

  // const showConfirmationAlert = () => {
  //     MySwal.fire({
  //         title: 'Are you sure?',
  //         text: 'You won\'t be able to revert this!',
  //         showCancelButton: true,
  //         confirmButtonColor: '#00ff00',
  //         confirmButtonText: 'Yes, delete it!',
  //         cancelButtonColor: '#ff0000',
  //         cancelButtonText: 'Cancel',
  //     }).then((result) => {
  //         if (result.isConfirmed) {

  //             MySwal.fire({
  //                 title: 'Deleted!',
  //                 text: 'Your file has been deleted.',
  //                 className: "btn btn-success",
  //                 confirmButtonText: 'OK',
  //                 customClass: {
  //                     confirmButton: 'btn btn-success',
  //                 },
  //             });
  //         } else {
  //             MySwal.close();
  //         }

  //     });
  // };

  const { currentPage, pageSize, totalPages, totalCount } = pagination;
  const startItem = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(startItem + pageSize - 1, totalCount);

  // CHANGE: Slice filteredPurchases for the current page
  const paginatedPurchases = filteredPurchases.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // CHANGE: Generate pages to show in pagination
  const pagesToShow = [];
  if (totalPages > 0) {
    if (totalPages <= 2) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      let middle = [];
      if (currentPage === 1) {
        middle = [1, 2];
      } else if (currentPage === totalPages) {
        middle = [totalPages - 1, totalPages];
      } else {
        middle = [currentPage, currentPage + 1];
      }
      if (middle[0] > 1) {
        pagesToShow.push(1);
      }
      if (middle[0] > 2) {
        pagesToShow.push("...");
      }
      middle.forEach((p) => pagesToShow.push(p));
      if (middle[1] < totalPages - 1) {
        pagesToShow.push("...");
      }
      if (middle[1] < totalPages) {
        pagesToShow.push(totalPages);
      }
    }
  }

  // CHANGE: Handle page change
  const changePage = (page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
    // Optionally refetch data if API supports server-side pagination
    // fetchPurchases(page, pagination.pageSize);
  };

  const columns = [
    {
      title: "Supplier Name",
      dataIndex: "supplier_name",
      render: (text) => <span className="wrap-text">{text}</span>,
      sorter: (a, b) =>
        (a.supplier_name || "").length - (b.supplier_name || "").length,
      width: 200,
    },
    {
      title: "Date",
      dataIndex: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => {
        const date = new Date(text);
        return isNaN(date)
          ? "N/A"
          : date
              .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })
              .split("/")
              .join("-");
      },
      width: 150,
    },
    {
      title: "Reference",
      dataIndex: "reference",
      render: (text) => <span className="wrap-text">{text}</span>,
      sorter: (a, b) => (a.reference || "").length - (b.reference || "").length,
      width: 200,
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => (a.status || "").length - (b.status || "").length,
      render: (text) => (
        <span className="badge" style={{ backgroundColor: "#D10000" }}>
          {text === "returned" ? "Returned" : text}
        </span>
      ),
      width: 100,
    },
    {
      title: "Grand Total (PKR)",
      dataIndex: "total",
      sorter: (a, b) => (a.total || 0) - (b.total || 0),
      render: (text) => `PKR ${text || "0.00"}`,
      width: 150,
    },
    {
      title: "Paid (PKR)",
      dataIndex: "paid",
      sorter: (a, b) => (a.paid || 0) - (b.paid || 0),
      render: (text) => `PKR ${text || "0.00"}`,
      width: 150,
    },
    {
      title: "Due (PKR)",
      dataIndex: "due",
      sorter: (a, b) => (a.due || 0) - (b.due || 0),
      render: (text) => `PKR ${text || "0.00"}`,
      width: 150,
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      sorter: (a, b) =>
        (a.payment_status || "").length - (b.payment_status || "").length,
      render: (text) => (
        <span
          className="badge"
          style={{
            backgroundColor: text === "paid" ? "#EBF8F2" : "#FFE5E5",
            color: text === "paid" ? "#49BE96" : "#FF4D4F",
          }}
        >
          {text === "paid" ? "Paid" : "Unpaid"}
        </span>
      ),
      width: 150,
    },
  ];

  

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Purchase Return List</h4>
                <h6>Manage your Returns</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={() => {
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {/* <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-sales-new"
                            >
                                 <PlusCircle className="me-2"/>
                                Add Purchase Return
                            </Link>
                        </div> */}
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search by supplier name and reference"
                      className="form-control form-control-sm formsearch"
                      onChange={handleSearch}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  columns={columns}
                  // dataSource={filteredPurchases}
                  dataSource={paginatedPurchases}
                  rowKey={(record) => record.id || record.reference}
                  rowSelection={null}
                  pagination = {false}
                />
              </div>

              {totalCount > 0 && (
                <div className="custom-pagination d-flex justify-content-between align-items-center mt-4 mb-4">
                  <div className="pagination-left">
                    Showing {startItem} - {endItem} of {totalCount}
                  </div>
                  <div className="pagination-right d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-outline-secondary me-2"
                      disabled={currentPage === 1}
                      onClick={() => changePage(currentPage - 1)}
                    >
                      <LeftOutlined size={12} />
                    </button>
                    {pagesToShow.map((page, index) => (
                      <span key={index} className="me-2">
                        {page === "..." ? (
                          <span className="pagination-ellipsis">...</span>
                        ) : (
                          <button
                            className={`btn btn-sm ${
                              page === currentPage
                                ? "btn-primary"
                                : "btn-outline-secondary"
                            }`}
                            onClick={() => changePage(page)}
                          >
                            {page}
                          </button>
                        )}
                      </span>
                    ))}
                    <button
                      className="btn btn-sm btn-outline-secondary ms-2"
                      disabled={currentPage === totalPages}
                      onClick={() => changePage(currentPage + 1)}
                    >
                      <RightOutlined size={12} />
                    </button>
                  </div>
                </div>
              )}
              {/* <div className="table-responsive">
                                <table className="table datanew">
                                    <thead>
                                        <tr>
                                            <th>Supplier Name</th>
                                            <th>Date</th>
                                            <th>Reference</th>
                                            <th>Status</th>
                                            <th>Grand Total ($)</th>
                                            <th>Paid ($)</th>
                                            <th>Due ($)</th>
                                            <th>Payment Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredPurchases.length > 0 ? (
                                            filteredPurchases.map((purchase, index) => (
                                                <tr key={index}>
                                                    <td>{purchase.supplier_name}</td>
                                                    <td>
                                                        {purchase.date
                                                            ? purchase.date.split('-').reverse().join('-')
                                                        : 'N/A'}
                                                    </td>
                                                    <td>{purchase.reference}</td>
                                                    <td>
                                                        {purchase.status === 'returned' && (
                                                            <span className="badge" style={{backgroundColor: '#D10000'}}>Returned</span>
                                                        )}
                                                    </td>
                                                    <td>${purchase.total || '0.00'}</td>
                                                    <td>${purchase.paid || '0.00'}</td>
                                                    <td>${purchase.due || '0.00'}</td>
                                                    <td>
                                                        {purchase.payment_status === 'unpaid' && (
                                                            <span className="badge" style={{backgroundColor: '#FFE5E5', color: '#FF4D4F'}}>Unpaid</span>

                                                        )}
                                                        {purchase.payment_status === 'paid' && (
                                                            <span className="badge" style={{backgroundColor: '#EBF8F2', color: '#49BE96'}}>Paid</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    No purchases found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div> */}
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddPurchaseReturn />
      <EditPurchaseReturns />
    </div>
  );
};

export default PurchaseReturns;
